export default function MapaCard() {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-md overflow-hidden">
      {/* Encabezado con línea naranja y dirección */}
      <div className="flex items-start gap-3 px-5 md:px-6 py-4 md:py-5 border-b border-gray-100">
        <div className="w-1 h-10 bg-primary rounded-full flex-shrink-0 mt-0.5" />
        <div>
          <p className="text-masmed-gray-900 text-base md:text-lg leading-tight"
          style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 700 }}>
            Universidad Arturo Prat
          </p>
          <p className="text-masmed-gray-500 text-sm mt-1 leading-relaxed">
            Av. Arturo Prat Chacón #2120
            <br />
            Iquique, I Región de Tarapacá (Chile)
          </p>
        </div>
      </div>

      {/* Mapa real de Google Maps con pin rojo superpuesto */}
      <div className="relative w-full h-56 md:h-72 lg:h-80 overflow-hidden">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.729084162427!2d-70.141277!3d-20.244026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x915216f6d6f6d6f6%3A0x6f6f6f6f6f6f6f6f!2sUniversidad%20Arturo%20Prat!5e0!3m2!1ses!2scl!4v1700000000000!5m2!1ses!2scl"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Mapa Universidad Arturo Prat"
          className="grayscale-[20%]"
        />

        {/* Pin rojo grande centrado sobre el mapa */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="relative -mt-6">
            {/* Cabeza del pin */}
            <div className="w-10 h-10 md:w-12 md:h-12 bg-red-500 rounded-full flex items-center justify-center shadow-xl">
              <i className="ri-map-pin-2-fill text-white text-xl md:text-2xl" />
            </div>
            {/* Punta del pin */}
            <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[7px] border-l-transparent border-r-[7px] border-r-transparent border-t-[10px] border-t-red-500" />
            {/* Sombra del pin */}
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-5 h-2 bg-black/15 rounded-full blur-sm" />
          </div>
        </div>
      </div>
    </div>
  );
}